import { render, staticRenderFns } from "./detailInfoTraining.vue?vue&type=template&id=226dfbee&scoped=true"
import script from "./detailInfoTraining.vue?vue&type=script&lang=js"
export * from "./detailInfoTraining.vue?vue&type=script&lang=js"
import style0 from "./detailInfoTraining.vue?vue&type=style&index=0&id=226dfbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226dfbee",
  null
  
)

export default component.exports